import { getMerchantSummaryCookieClient } from "../functions/cookies";
import LocaleCurrency from "locale-currency";

export { }
declare global {
    export interface Number {
        toLocalePrice(): string;
        customRound(decimalPlaces: number): number;
        roundAwayFromZero(decimals: number): number;
    }
}

Number.prototype.toLocalePrice = function (): string {
    let locale: string = 'pt-BR'
    let currency: string = 'BRL'

    if (typeof document !== 'undefined') {
        const merchant = getMerchantSummaryCookieClient();

        if (merchant)
            locale = merchant.language
    }

    const localeCurrency = LocaleCurrency.getCurrency(locale);

    return this.toLocaleString(locale, {
        style: 'currency',
        currency: localeCurrency || currency
    })
}

Number.prototype.customRound = function (decimalPlaces: number): number {
    let factor = Math.pow(10, decimalPlaces);
    return (Math.round(Number(this) * factor) / factor);
}

Number.prototype.roundAwayFromZero = function (decimals: number): number {
    const factor = 10 ** decimals;
    const absValue = Math.abs(Number(this));
    // “fudge” para compensar imprecisão: EPSILON * magnitude aproximada
    const fudge = Number.EPSILON * absValue * factor;
    const roundedAbs = Math.floor(absValue * factor + 0.5 + fudge) / factor;
    return Math.sign(Number(this)) * roundedAbs;
}